<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <el-button
      :disabled="!editable"
      :style="inputStyle"
      type="primary"
      size="small"
      @click="submit"
    >
      {{ buttonText }}
    </el-button>
  </div>
</template>

<script>
import Validator from '../../utils/validator.js'
import _ from 'lodash'

export default {
  name: 'jtStatusButton',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    compWidth: {
      type: String,
      default: '100%',
    },
    tooltip: {
      type: String,
      default: '此操作将提交数据，提交后将不得编辑，是否继续？',
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '提交',
    },
  },
  data() {
    return {
      type: this.maxLength >= 100 ? 'textarea' : 'text',
      rows: this.maxLength > 200 ? 8 : 5,
      val: this.value,
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      inputStyle: {
        width: window.innerWidth > 768 ? this.compWidth : '100%',
      },
      hasFiredEnterEventHandler: false,
    }
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },

    submit() {
       this.$emit('buttonSubmit',this.tooltip)
    },
  },
  watch: {
    value(newValue) {
      this.val = newValue
    },
  },
}
</script>

<style lang="stylus">
.component-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.component-container .is-disabled .el-input__inner {
  color: #666666;
}

.xing {
  color: #fff;
  margin-right: 5px;
}
</style>
